var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ib-col", [
    _vm.status === "loading"
      ? _c(
          "div",
          { staticClass: "alignment" },
          [
            _c("ib-progress-circular", {
              attrs: { width: "128px", height: "128px" },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.status === "prodResults"
      ? _c(
          "div",
          [
            _c("div", { staticClass: "product-results" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(_vm.selectedExch) +
                    " (" +
                    _vm._s(_vm.selectedExch) +
                    ")"
                ),
              ]),
              _c(
                "div",
                { staticClass: "start-download" },
                [
                  _c(
                    "ib-button",
                    {
                      staticClass: "dark-grey-text start",
                      attrs: { id: "download" },
                      on: { click: _vm.downloadMapping },
                    },
                    [_vm._v(_vm._s(_vm.$t("download_to_xls")))]
                  ),
                  _vm.exchIdParam.length === 0
                    ? _c(
                        "ib-button",
                        {
                          staticClass: "dark-grey-text start",
                          on: { click: _vm.startOver },
                        },
                        [_vm._v(_vm._s(_vm.$t("start_over")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "ib-tab-bar",
              {
                staticClass: "result-tabs",
                model: {
                  value: _vm.selectedOption,
                  callback: function ($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption",
                },
              },
              [
                _c(
                  "ib-tab2",
                  {
                    key: "products",
                    staticClass: "tab",
                    class: { tab_style: _vm.selectedOption === "products" },
                  },
                  [_vm._v(_vm._s(_vm.$t("products")))]
                ),
                _c(
                  "ib-tab2",
                  {
                    key: "order types",
                    staticClass: "tab",
                    class: { tab_style: _vm.selectedOption === "order types" },
                  },
                  [_vm._v(_vm._s(_vm.$t("order_types")))]
                ),
              ],
              1
            ),
            _vm.selectedOption === "products"
              ? _c("div", { staticClass: "view" }, [
                  _c("div", { staticClass: "search" }, [
                    _c(
                      "div",
                      { staticClass: "flex-flex" },
                      [
                        _c("ib-field", {
                          staticClass: "ticker-field",
                          attrs: {
                            placeholder: _vm.$t("product_symbol"),
                            autofocus: "",
                            width: "100%",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.checkValidation(_vm.searchTerm)
                            },
                          },
                          model: {
                            value: _vm.searchTerm,
                            callback: function ($$v) {
                              _vm.searchTerm = $$v
                            },
                            expression: "searchTerm",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "bg15-inverse cancel",
                            on: {
                              click: function ($event) {
                                return _vm.clearField(true)
                              },
                            },
                          },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                                  fill: "#fff",
                                },
                              }),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          { staticClass: "magnify", on: { click: _vm.submit } },
                          [
                            _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                              _c("path", {
                                attrs: {
                                  d: "M21 3C11.6 3 4 10.6 4 20a16.99 16.99 0 0 0 26.1 14.34l12.27 12.28 4.26-4.24-12.13-12.1A16.99 16.99 0 0 0 21 3zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z",
                                },
                              }),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "options" },
                      [
                        _c(
                          "ib-button",
                          {
                            staticClass: "mt-2",
                            class: {
                              active: _vm.selectedProductType === "all",
                            },
                            attrs: { width: "100%" },
                            on: {
                              click: function ($event) {
                                return _vm.prodType("all", "")
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "typeValue" }, [
                              _vm._v(_vm._s(_vm.$t("show_all"))),
                            ]),
                            _c("br"),
                            _c("span", { staticClass: "total" }, [
                              _vm._v(_vm._s(_vm.total)),
                            ]),
                          ]
                        ),
                        _vm._l(_vm.types, function (type, index) {
                          return _c(
                            "ib-button",
                            {
                              key: index,
                              staticClass: "mt-2",
                              class: {
                                active: _vm.selectedProductType === type.symbol,
                              },
                              attrs: { width: "100%" },
                              on: {
                                click: function ($event) {
                                  return _vm.prodType(type.symbol, "")
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "typeValue" }, [
                                _vm._v(_vm._s(_vm.$t(type.name))),
                              ]),
                              _c("p", [_vm._v(_vm._s(type.totalCount))]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "results" },
                    [_c("ProductSearchResults")],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.selectedOption === "order types"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "orderTypeTable" },
                    [
                      _c(
                        "ib-table-basic",
                        {
                          staticStyle: {
                            border: "1px solid rgba(0,0,0,0.15)",
                            "overscroll-behavior": "contain",
                          },
                          attrs: {
                            data: _vm.orderTypesResults,
                            row: "",
                            colborder: "",
                            rowstripe: "",
                            spacing: "huge",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function (res) {
                                  return [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "description",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openLink(res["native"])
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(_vm._s(res["native"])),
                                        _vm.isAssetType(res)
                                          ? _c("span", [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    viewBox: "0 0 50 50",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M38.04 13.99c-.41-.01-.78.23-.95.6a1 1 0 0 0 .21 1.1L45.28 24H2.02a1 1 0 0 0-.87.5 1 1 0 0 0 0 1 1 1 0 0 0 .87.5h43.26l-7.98 8.3a1 1 0 1 0 1.45 1.4L49 25 38.75 14.3a1 1 0 0 0-.71-.31z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm.isAssetType(res)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "assetDescription",
                                              },
                                              [
                                                _vm._v(
                                                  " (" +
                                                    _vm._s(res["assetType"]) +
                                                    ")"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "description",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openLink(res["simulate"])
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(_vm._s(res["simulate"])),
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 50 50" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M38.04 13.99c-.41-.01-.78.23-.95.6a1 1 0 0 0 .21 1.1L45.28 24H2.02a1 1 0 0 0-.87.5 1 1 0 0 0 0 1 1 1 0 0 0 .87.5h43.26l-7.98 8.3a1 1 0 1 0 1.45 1.4L49 25 38.75 14.3a1 1 0 0 0-.71-.31z",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "assetDescription" },
                                          [
                                            _vm._v(
                                              " (" +
                                                _vm._s(res["assetType"]) +
                                                ")"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3365491834
                          ),
                        },
                        [
                          _c(
                            "ib-table-col",
                            {
                              staticClass: "header",
                              attrs: { width: "20ch", sticky: "" },
                            },
                            [
                              _c("div", { staticClass: "border-bottom" }, [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      title: _vm.$t("native_by_exchange"),
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("native_by_exchange")))]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "ib-table-col",
                            {
                              staticClass: "header",
                              attrs: { width: "45ch", sticky: "" },
                            },
                            [
                              _c("div", { staticClass: "border-bottom" }, [
                                _c(
                                  "span",
                                  {
                                    attrs: { title: _vm.$t("simulated_by_ib") },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("simulated_by_ib")))]
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("order_type_footer_1"))),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        )
      : _vm.status === "failed"
      ? _c("div", [
          _c("span", { staticClass: "warnings" }, [
            _c("svg", { attrs: { viewBox: "0 0 28 25" } }, [
              _c("path", {
                attrs: {
                  fill: "#ffc107",
                  d: "M1.5 24.8a1.5 1.5 0 01-1.3-2.2L12.7.9a1.5 1.5 0 012.6 0l12.5 21.7a1.5 1.5 0 01-1.3 2.2z",
                },
              }),
              _c("path", {
                attrs: { fill: "#000", d: "M12.9 17.4L12.5 8h3l-.4 9.4h-2.3z" },
              }),
              _c("circle", {
                attrs: { fill: "#000", cx: "14", cy: "20.6", r: "1.5" },
              }),
            ]),
          ]),
          _c("span", { staticClass: "warning-message" }, [
            _vm._v("There is no data available for the requested exchange."),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }